import { render } from "./rooms.vue?vue&type=template&id=11ff982c"
import script from "./rooms.vue?vue&type=script&lang=js"
export * from "./rooms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__